import axios from "axios";

export default {
    data() {
        return {
            errors: {},
            response: {
                //
            },
        }
    },
    computed: {
        combinedErrors() {
            if (this.$parent) return {...this.$parent.errors, ...this.errors}
            else return this.errors
        },
    },
    methods: {
        makeRequest(method, url, data = null, response = () => {}, error = () => {}, final = () => {}) {
            this.resetErrors()
            axios({ url, method, data })
                .then(r => {
                    if (r.data.message) window.toastr.success(r.data.message, '', {
                        positionClass: 'toast-bottom-right',
                    })
                    response(r)
                })
                .catch(e => {
                    if (e.response.status === 422) {
                        this.errors = e.response.data.errors
                    }

                    if (e.response.data) window.toastr.error(e.response.data, '', {
                        positionClass: 'toast-bottom-right',
                    })

                    error(e)
                })
                .finally(() => final())
        },
        hasError(field) {
            return this.combinedErrors[field]
        },
        getError(field) {
            return this.combinedErrors[field][0]
        },
        resetErrors() {
            this.errors = {}
            if (this.$parent) this.$parent.errors = {}
        },
    },
}
